<template>
  <div class="sidebar">
    <div class="sidebar" :class="{'sidebar-active':isActive}">
      <a
        v-if="!isActive"
        class="button toggle-sidebar-btn is-semibold-16-600-19"
        style="border:none;writing-mode: vertical-rl;text-orientation: mixed;height:100vh;width:40px"
        @click="toggle_sidebar()"
      >
        <template v-if="container && container.name">{{'Terra - '+ container.name}}</template>
        <img
          class="toggle-sidebar-btn is-semibold-16-600-19"
          style="border:none;right:-22px"
          @click.stop="toggle_sidebar()"
          src="@/assets/icons/expand-collapse.svg"
        />
      </a>
      <a
        v-else
        class="toggle-sidebar-btn is-semibold-16-600-19"
        style="border:none;top:45vh;right:-22px"
        @click="toggle_sidebar()"
      >
        <img src="@/assets/icons/expand.svg" />
      </a>
      <div class="card sidebar__card">
        <div class="card-header has-text-centered" style="box-shadow:none">
          <h2
            v-if="container"
            style="font-weight:500;"
            class="is-semiBold-16-600-19 card-header-title viewer-name"
          >{{'Terra - '+ container.name || '{Name}' }}</h2>
        </div>
        <div class="card-content" style="padding:0">
          <div class="content">
            <nav-menu class="nav-menu"></nav-menu>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import NavMenu from "./components/menu/nav-menu.component";
export default {
  data() {
    return {
      isActive: true
    };
  },
  computed: {
    ...mapState(["container"])
  },
  created() {
    this.$root.$on("sidebar_toggle", () => {
      parent.postMessage({ name: "sidebar_toggle", open: this.isActive }, "*");
    });
  },
  methods: {
    toggle_sidebar() {
      this.isActive = !this.isActive;
      this.$emit('sidebar',this.isActive)
      parent.postMessage({ name: "sidebar_toggle", open: this.isActive }, "*");
    }
  },
  components: {
    NavMenu,
  }
};
</script>

<style lang="scss" scoped>
.sidebar {
  height: 0;
  &__card .card-content {
    padding: 0 1rem;
  }
  &__card .card-header-title.viewer-name {
    justify-content: center;
    color: #171e48;
    margin-top: 0.5rem;
  }
}
.toggle-sidebar-btn {
  position: absolute;
  // top: 200px;
  z-index: 1;
  right: -40px;
  height: auto;
  transition: all 0.5s;
  border: none;
  border-radius: 0;
  padding: 3px;
}
.sidebar {
  position: fixed;
  width: 22rem;
  left: -22rem;
  top: 0px;
  z-index: 999;
  transition: all 0.5s;
  &__card {
    height: 100vh;
  }

  .nav-menu {
    height: 69vh;
  }
  &-active {
    left: 0%;
  }
}
</style>
